import { render, staticRenderFns } from "./CustomerCardDefaultPaymentType.vue?vue&type=template&id=25297f20&scoped=true"
import script from "./CustomerCardDefaultPaymentType.vue?vue&type=script&lang=ts"
export * from "./CustomerCardDefaultPaymentType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25297f20",
  null
  
)

export default component.exports